const ROUND_PRECISION = 1;
//================================================================================================
//                                  Results Column Function
/* Creates the columns and adds the cells to the columns for a DataColumn
    Each main cell consists of an array of cells
    within the array of cells, the first cell is the value of the cell. e.g. the Value for the Season.
    The next lot of cells are the values for the lsd groups
 */
//================================================================================================
export const getTrialDataColumns = (data, currentResultCategory) => {
    var _a;
    let columns = [];
    if (data) {
        const trialData = JSON.parse((_a = data[0].trialData) !== null && _a !== void 0 ? _a : "[]");
        const filteredData = trialData.filter((item) => item.resultCategory === currentResultCategory);
        //get a reduced array of the columns
        const reducedColumns = [
            { columnIndex: 0, columnName: "varietyName" },
            ...trialData
                .filter((item) => item.resultCategory === currentResultCategory && item.meanValue > 0)
                .map((item, index) => ({
                columnIndex: index + 1,
                columnName: toCamelCase(item.resultColumns),
            }))
                .filter((value, index, self) => self.findIndex((v) => v.columnName === value.columnName) === index),
        ];
        for (let i = 0; i < reducedColumns.length; i++) {
            columns.push({
                name: reducedColumns[i].columnName,
                originalDisplayIndex: i + 1,
                sortedDisplayIndex: i + 1,
                columnIndex: i + 1,
                columnCells: [],
            });
        }
        if (filteredData && filteredData.toString() === "No data found") {
            return columns;
        }
        //================================================================================================
        //                                COLUMN CELLS
        // foreach column add the cells to the column from the results based on the column index
        // the cell value is the first item in the array of cells
        // the rest of the cells are the lsd groups
        //================================================================================================
        const distinctVarieties = filteredData
            .map((item) => item.varietyName)
            .filter((value, index, self) => self.indexOf(value) === index);
        columns.forEach((column, cIndex) => {
            let rowIndex = 0;
            let colSpan = 1;
            filteredData.forEach((result) => {
                if (result.resultColumns !== column.name) {
                    if (column.name === "varietyName") {
                        colSpan = 2;
                        distinctVarieties.forEach((variety, index) => {
                            const cell = {
                                cellValue: variety,
                                cellNumericValue: 0,
                                rowLsdColumns: [],
                                lsdGroup: -1,
                                displayIndex: index,
                                columnIndex: column.columnIndex,
                                columnName: column.name,
                                rowIndex: index,
                                colSpan: 1,
                                cellItems: [],
                            };
                            column.columnCells.push(cell);
                        });
                    }
                    return;
                }
                //================================================================================================
                //                                COLUMN CELLS - First Cell Row
                // For the first row index we need to add the column Names for each cell
                //================================================================================================
                if (rowIndex === 0) {
                    const cell = {
                        cellValue: roundValue(result.meanValue.toString(), ROUND_PRECISION, false),
                        cellNumericValue: roundValue(result.meanValue.toString(), ROUND_PRECISION, true),
                        rowLsdColumns: [],
                        lsdGroup: -1,
                        displayIndex: rowIndex,
                        columnIndex: column.columnIndex,
                        columnName: column.name,
                        rowIndex: rowIndex,
                        colSpan: colSpan,
                        cellItems: [],
                    };
                    column.columnCells.push(cell);
                }
                else {
                    const cell = {
                        //Rounded cell value if numeric || Cell Value
                        cellValue: roundValue(result.meanValue.toString(), ROUND_PRECISION, false),
                        cellNumericValue: roundValue(result.meanValue.toString(), ROUND_PRECISION, true),
                        rowLsdColumns: [],
                        lsdGroup: -1,
                        displayIndex: rowIndex,
                        columnIndex: column.columnIndex,
                        columnName: column.name,
                        rowIndex: rowIndex,
                        colSpan: 1,
                        cellItems: [],
                    };
                    column.columnCells.push(cell);
                }
                rowIndex++;
            });
        });
    }
    lsdColumnsForRows(data, columns);
    console.log("Columns: ", columns);
    return columns;
};
function lsdColumnsForRows(trialData, columns) {
    //For each of the columns
    columns.forEach((column) => {
        if (column.name !== "varietyName") {
            console.log("Column Name check for lsd: ", column.name);
            column.columnCells.forEach((cell) => {
                console.log("Cell Value check for lsd: ", cell.cellValue);
            });
        }
    });
    //For each of the dataCells in a column
}
// takes in the trial data and returns the columns (DataColumn) containing the cells (DataCell) and the items (DataCellItem)
export const getResultColumns = (trialData) => {
    let columns = [];
    columns.push({
        name: "VarietyName",
        originalDisplayIndex: 0,
        sortedDisplayIndex: 0,
        columnIndex: 0,
        columnCells: [],
    });
    //console.log("Trial Data: ", trialData);
    if (trialData && trialData.toString() === "No data found") {
        return columns;
    }
    trialData.forEach((data) => {
        //================================================================================================
        //                                JSON DATA - JSON COLUMNS, LSD VALUE, JSON RESULT
        //================================================================================================
        //Is the data JSON if not return the columns
        if (!data.jsonColumns || !data.lsdValue || !data.jsonResult) {
            return columns;
        }
        const resultColumns = data.jsonColumns ? camelCaseFromPascalCaseJson(data.jsonColumns) : columns;
        if (!resultColumns) {
            return columns;
        }
        const lsdValues = camelCaseFromPascalCaseJson(data.lsdValue);
        if (!lsdValues) {
            return columns;
        }
        const results = camelCaseFromPascalCaseJson(data.jsonResult);
        if (!results) {
            return columns;
        }
        let rowIndex = 0;
        let colSpan = 1;
        //================================================================================================
        //                                CELLS AND CELL ITEMS
        //================================================================================================
        // Add the columns to the columns array
        resultColumns.forEach((column, index) => {
            var _a, _b;
            index++;
            const lsdValue = (_a = lsdValues.find((lsd) => toCamelCase(lsd.columnName) === toCamelCase(column.columnName))) === null || _a === void 0 ? void 0 : _a.lsdValue;
            columns.push({
                name: column.columnName,
                originalDisplayIndex: column.displayIndex,
                sortedDisplayIndex: column.displayIndex,
                columnIndex: index,
                backgroundColor: column.backgroundColor,
                lsdValue: lsdValue,
                columnCells: [],
                dataResultUnit: (_b = column.dataResultUnit) !== null && _b !== void 0 ? _b : "kg/ha",
                dataResultTypeId: column.dataResultTypeId,
                dataResultTypeName: column.dataResultTypeName,
            });
        });
        //================================================================================================
        //                                COLUMN CELLS
        // foreach column add the cells to the column from the results based on the column index
        // the cell value is the first item in the array of cells
        // the rest of the cells are the lsd groups
        //================================================================================================
        columns.forEach((column) => {
            rowIndex = 0;
            results
                // filter on DataResultTypeId if CategoryName = "Quality"
                .filter((result) => {
                if (data.categoryName === "Quality") {
                    return result.dataResultTypeId === column.dataResultTypeId;
                }
                return true;
            })
                .forEach((result, resultIndex) => {
                const columnName = toCamelCase(column.name.replace(/[\]']+/g, "").replace(/ /g, ""));
                if (toCamelCase(column.name) === "varietyName") {
                    colSpan = 2;
                }
                //================================================================================================
                //                                COLUMN CELLS - First Cell Row
                // For the first row index we need to add the column Names for each cell
                //================================================================================================
                if (rowIndex === 0) {
                    const cellValue = result[toCamelCase(column.name)];
                    const cell = {
                        cellValue: toCamelCase(column.name) === "varietyName"
                            ? cellValue
                            : roundValue(cellValue, ROUND_PRECISION, false),
                        cellNumericValue: toCamelCase(column.name) === "varietyName"
                            ? 0
                            : roundValue(cellValue, ROUND_PRECISION, true),
                        rowLsdColumns: [],
                        lsdGroup: -1,
                        displayIndex: rowIndex,
                        columnIndex: column.columnIndex,
                        columnName: columnName,
                        rowIndex: rowIndex,
                        colSpan: colSpan,
                        cellItems: [],
                        dataResultTypeId: column.dataResultTypeId,
                    };
                    column.columnCells.push(cell);
                }
                else {
                    const cellValue = result[toCamelCase(column.name)];
                    const cell = {
                        //Rounded cell value if numeric || Cell Value
                        cellValue: toCamelCase(column.name) === "varietyName"
                            ? cellValue
                            : roundValue(cellValue, ROUND_PRECISION, false),
                        cellNumericValue: toCamelCase(column.name) === "varietyName"
                            ? 0
                            : roundValue(cellValue, ROUND_PRECISION, true),
                        rowLsdColumns: [],
                        lsdGroup: -1,
                        displayIndex: rowIndex,
                        columnIndex: column.columnIndex,
                        columnName: columnName,
                        rowIndex: rowIndex,
                        colSpan: 1,
                        cellItems: [],
                        dataResultTypeId: column.dataResultTypeId,
                    };
                    column.columnCells.push(cell);
                }
                rowIndex++;
            });
        });
    });
    //sorted by the cellItem value of the first item in the ColumnCells array
    let sortedColumns = columns.map((column) => {
        column.columnCells.sort((a, b) => {
            const aValue = parseFloat(a.cellValue);
            const bValue = parseFloat(b.cellValue);
            if (isNaN(aValue) || isNaN(bValue)) {
                return 0; // If either value is NaN, consider them equal for sorting purposes
            }
            return bValue - aValue;
        });
        // Iterate over the cells in the column and add DataCellItems to the DataCell based on LSD Values
        // if there are no more items to add in the group then increment the Cellgroup value
        let lsdColumnArray = [];
        //set number[] based on number of rows in the column
        lsdColumnArray = Array.from({ length: column.columnCells.length }, (_, i) => i);
        // Comparison values
        let currentCellValue = 0;
        let lsdValue = 0;
        if (!column.lsdValue) {
            return column;
        }
        lsdValue = roundValue(column.lsdValue.toString(), ROUND_PRECISION, true);
        //==========================================================================================================
        //                               LSD GROUPS
        //
        //==========================================================================================================
        let newLsdGroupArray = [];
        lsdColumnArray.forEach((lsdColumnIndex) => {
            const newLsdGroup = {
                columnName: column.name,
                groupIndex: lsdColumnIndex,
                comparisonValue: currentCellValue,
                items: [],
            };
            getCellsWithinLsdGroup(column.columnCells, lsdColumnIndex, lsdValue).forEach((cell, cellIndex) => {
                if (cellIndex === 0) {
                    newLsdGroup.comparisonValue = roundValue(cell.cellValue.toString(), ROUND_PRECISION, true); //parseInt(cell.CellValue);
                }
                const lsdGroupItem = {
                    name: cell.columnName,
                    rowIndex: cell.rowIndex,
                    currentCellValue: roundValue(cell.cellValue.toString(), ROUND_PRECISION, true),
                };
                if (newLsdGroup && newLsdGroup.items) {
                    newLsdGroup.items.push(lsdGroupItem);
                }
                cell.rowLsdColumns.push(lsdColumnIndex);
            });
            newLsdGroupArray.push(newLsdGroup);
        });
        //starting from the last item to the first in the newLsdGroupArray
        // if the last item in the newLsdGroupArray.LsdGroup.Items of the current iteration is equal to
        // the next array item in the last item of newLsdGroupArray.LsdGroup.Items then remove the last newLsdGroupArray.LsdGroup from the array
        let sortedLsdGroupArray = [];
        const lsdGroupsForRemoval = [];
        let currentTopValue = 0;
        let currentBottomValue = 0;
        let previousTopValue = 0;
        let previousBottomValue = 0;
        newLsdGroupArray
            //.filter((lsdGroup) => lsdGroup.ColumnName === "Autumn")
            .forEach((lsdGroup, lsdGroupIndex) => {
            //return if CurrentCellValue is undefined
            if (!lsdGroup.items[0] || !lsdGroup.items[0].currentCellValue) {
                return;
            }
            currentTopValue = lsdGroup.items[0].currentCellValue;
            currentBottomValue =
                lsdGroup.items[lsdGroup.items.length - 1].currentCellValue;
            const previousGroup = newLsdGroupArray[lsdGroupIndex - 1];
            if (lsdGroup.items &&
                previousGroup &&
                previousGroup.items &&
                previousGroup.items.length > 0 &&
                previousGroup.items[0].currentCellValue &&
                previousGroup.items[previousGroup.items.length - 1].currentCellValue) {
                try {
                    previousTopValue = previousGroup.items[0].currentCellValue;
                    previousBottomValue =
                        previousGroup.items[previousGroup.items.length - 1]
                            .currentCellValue;
                    //if currentTopValue and currentBottom Value are within the previousTopValue and previousBottomValue then remove the current lsdGroup
                    if (currentTopValue <= previousTopValue &&
                        currentBottomValue === previousBottomValue) {
                        lsdGroupsForRemoval.push(lsdGroup.groupIndex);
                    }
                }
                catch (e) {
                    console.log("Error: ", e);
                }
            }
        });
        sortedLsdGroupArray = newLsdGroupArray.filter((lsdGroup) => !lsdGroupsForRemoval.includes(lsdGroup.groupIndex));
        column.lsdColumnCount = sortedLsdGroupArray.length;
        //sort by group index , then renumber the group index based on ordinal index of forEach
        sortedLsdGroupArray
            .sort((a, b) => a.groupIndex - b.groupIndex)
            .forEach((lsdGroupItem, lsdGroupIndex) => {
            lsdGroupItem.groupIndex = lsdGroupIndex;
        });
        column.columnCells.forEach((cell) => {
            cell.rowLsdColumns = [];
            sortedLsdGroupArray.forEach((lsdGroup) => {
                lsdGroup.items.forEach((lsdGroupItem) => {
                    if (lsdGroupItem.rowIndex === cell.rowIndex) {
                        cell.rowLsdColumns.push(lsdGroup.groupIndex);
                    }
                });
            });
        });
        //udpate column cells RowLsdColumns based on the newLsdGroupArray.GroupIndex
        return column;
    });
    //console.log(sortedColumns);
    return sortedColumns;
};
///================================================================================================
//                                  LSDGroup Array Function
// dataCells: DataCell[] - The array of DataCells to process
// lsdColumn: number -
// lsdValue: number - The lsd value to compare
//================================================================================================
const getCellsWithinLsdGroup = (dataCells, lsdColumn, lsdValue, firstCellInGroupValueForComparison = 0, isRecursive = false) => {
    var _a;
    // return all of them
    const dataCellsToReturn = [];
    ///console.log("Debug 2: ", dataCells);
    // Last lsdColumn comparison value
    let lastDataCellForComparison;
    lastDataCellForComparison =
        (_a = dataCells.find((cell) => cell.lsdGroup === lsdColumn - 1)) !== null && _a !== void 0 ? _a : dataCells[0];
    dataCells.forEach((rowCell, rowIndex) => {
        if (lsdColumn === 0 && rowIndex === 0) {
            rowCell.lsdGroup = 0;
            firstCellInGroupValueForComparison = roundValue(rowCell.cellValue.toString(), ROUND_PRECISION, true); // rowCell.CellNumericValue;
            dataCellsToReturn.push(rowCell);
            return;
        }
        else if (rowIndex > 0) {
            //process the following rows
            if (parseFloat(rowCell.cellValue) < parseFloat(lastDataCellForComparison.cellValue)) {
                // The current cell is less than the last cell group processed.
                if (dataCellsToReturn.length === 0) {
                    // this allows us to step through to the next group of cells
                    firstCellInGroupValueForComparison = roundValue(rowCell.cellValue.toString(), ROUND_PRECISION, true);
                }
                if (roundValue(rowCell.cellValue.toString(), ROUND_PRECISION, true) >=
                    firstCellInGroupValueForComparison - lsdValue) {
                    rowCell.lsdGroup = lsdColumn;
                    dataCellsToReturn.push(rowCell);
                    return;
                }
            }
        }
    });
    //if(lsdColumn === 1) console.log("Data Cells To Return: ", dataCellsToReturn);
    return dataCellsToReturn;
};
// Helper function to round a value if it is a number otherwise return the value
export const roundValue = (value, precision, convertToNumber = false) => {
    // If value is null, undefined, or empty string, return as is
    if (value === null || value === undefined || value === '') {
        return value;
    }
    const stringValue = value.toString();
    const numberValue = parseFloat(stringValue);
    // Check if the entire string is a valid number (not just starts with a number)
    if (!isNaN(numberValue) && stringValue.trim() === numberValue.toString()) {
        return convertToNumber
            ? Number(numberValue.toFixed(precision))
            : numberValue.toFixed(precision);
    }
    // Return original value if it's not a pure number
    return stringValue;
};
export const camelCaseFromPascalCaseJson = (json) => {
    const camelCase = (str) => str.charAt(0).toLowerCase() + str.slice(1);
    const convertKeysToCamelCase = (obj) => {
        if (Array.isArray(obj)) {
            return obj.map(v => convertKeysToCamelCase(v));
        }
        else if (obj !== null && obj.constructor === Object) {
            return Object.keys(obj).reduce((result, key) => {
                const camelKey = camelCase(key);
                result[camelKey] = convertKeysToCamelCase(obj[key]);
                return result;
            }, {});
        }
        return obj;
    };
    const parsedJson = JSON.parse(json);
    return convertKeysToCamelCase(parsedJson);
};
export const toCamelCase = (str) => {
    return str.charAt(0).toLowerCase() + str.slice(1);
};
